import getDomElementCoordinates from 'apps/catalogue/utils/getDomElementCoordinates';

export const findErrorMessageForField = (errors, fieldName) => {
  if (errors === null) {
    return null;
  }

  const relevantErrors = errors.filter((error) => error.field === fieldName);
  return relevantErrors.map(error => `${error.message} `).join(' ');
};

export const filterErrorMessageForField = (errors, fieldName) =>
  errors.filter((error) => error.field !== fieldName);

export const scrollToSelector = (targetSelector, event) => {
  if (event && event.preventDefault) {
    event.preventDefault();
  }

  const element = document.querySelector(targetSelector);
  const headerNode = document.querySelector('.rs-stickyHeader');
  const stickyTrolleyNode = document.querySelector('.bop-basketControls__sticky--desktopMode');

  if (!element || !headerNode || !stickyTrolleyNode) {
    return;
  }

  const elementOffset = getDomElementCoordinates(element).top;
  const headerHeight = headerNode.clientHeight;
  const stickyTrolleyHeight = stickyTrolleyNode.clientHeight;

  window.scrollTo({
    top: elementOffset - headerHeight - stickyTrolleyHeight - 16,
    left: 0,
    behavior: 'smooth',
  });
};

export const scrollToReviews = (event) => {
  const targetSelector = '#reviews';
  scrollToSelector(targetSelector, event);
};

export const scrollToCustomerReviews = (event) => {
  const targetSelector = '#customerReviews';
  scrollToSelector(targetSelector, event);
};
export const scrollToYourReview = (event) => {
  const targetSelector = '#yourReview';
  scrollToSelector(targetSelector, event);
};

export const scrollToShelfLife = (event) => {
  const targetSelector = '#bopShelfLife';
  scrollToSelector(targetSelector, event);
};
